module.exports = __webpack_public_path__ + "static/media/viveka-logo.3fc43153.png";